import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultEnum } from "../../types.client";
import { WirelessFieldStrengthMeasure } from "../../../models/schemas/measures/fieldStrength.schema";
import { WIRELESS_FIELD_STRENGTH_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * 무선신호 전계강도 컨트롤러
 * 3단계 판정 (WIRELESS_FIELD_STRENGTH_THRESHOLDS 사용):
 * - ≥excellent (150): 매우양호 (GOOD)
 * - ≥good (50): 양호 (GOOD)
 * - ≥min (15): 최소수신 통신가능 (GOOD)
 * - <min: 불량 (BAD)
 */
export class WirelessFieldStrengthController extends MeasureController<WirelessFieldStrengthMeasure> {
  protected getDefaultData(): WirelessFieldStrengthMeasure {
    return {
      standardValue: 0,
      measuredValue: 0,
      unit: "μV/m",
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
      createdAt: null,
    };
  }

  protected judge(): JudgmentResult {
    const { measuredValue = 0 } = this.data;
    const { min, good, excellent } = WIRELESS_FIELD_STRENGTH_THRESHOLDS;

    let result: "GOOD" | "CAUTION" | "BAD" | "NA";
    if (measuredValue >= excellent) {
      result = JudgmentResultEnum.GOOD;
    } else if (measuredValue >= good) {
      result = JudgmentResultEnum.GOOD;
    } else if (measuredValue >= min) {
      result = JudgmentResultEnum.GOOD; // 문서 기준: min 이상은 "통신가능"으로 GOOD
    } else {
      result = JudgmentResultEnum.BAD;
    }

    const discussion = this.generateDiscussion(result);

    return { result, discussion };
  }

  protected generateDiscussion(_result: "GOOD" | "CAUTION" | "BAD" | "NA"): string {
    const { measuredValue = 0 } = this.data;
    const { min, good, excellent } = WIRELESS_FIELD_STRENGTH_THRESHOLDS;

    if (measuredValue >= excellent) {
      return `측정값 ${measuredValue}μV/m, 매우양호 (${excellent}μV/m 이상)`;
    } else if (measuredValue >= good) {
      return `측정값 ${measuredValue}μV/m, 양호 (${good}~${excellent}μV/m)`;
    } else if (measuredValue >= min) {
      return `측정값 ${measuredValue}μV/m, 최소수신 (통신가능, ${min}~${good}μV/m)`;
    } else {
      return `측정값 ${measuredValue}μV/m, 불량 (${min}μV/m 미만)`;
    }
  }
}
